/**
 * pages/projects-map.js — Χάρτης Υφιστάμενων Έργων
 *
 * Renders a Google Map and loads project pins from the cacheable
 * whytheme_erga_map_points AJAX endpoint (GET, public, no nonce — see
 * inc/ajax/erga-ajax-handlers.php), optionally filtered by category.
 *
 * The active category always lives in the URL (?erga_category=slug on
 * this page), synced both ways:
 *  - on load, the filter + initial pins come from the URL (so a shared/
 *    reloaded link shows the right view even before any click),
 *  - clicking a filter re-fetches pins and pushes the new URL via
 *    history.pushState (with back/forward handled via popstate),
 * so filtering never invents state that only exists in memory.
 *
 * window.whythemeErgaMapData is localized server-side: { hasKey, ajaxUrl }
 */

var whythemeErgaMapInstance = null;
var whythemeErgaMapMarkers = [];
var whythemeErgaMapInfoWindow = null;

function whythemeEscapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
}

function whythemeErgaMapGetCategoryFromUrl() {
    return new URLSearchParams(window.location.search).get('erga_category') || '';
}

function whythemeErgaMapSetSkeleton(visible) {
    var skeleton = document.getElementById('erga-map-skeleton');
    if (skeleton) {
        skeleton.classList.toggle('hidden', !visible);
    }
}

function whythemeErgaMapSetActiveFilter(slug) {
    document.querySelectorAll('.js-erga-map-filter').forEach(function (link) {
        var active = (link.getAttribute('data-category') || '') === slug;
        link.classList.toggle('bg-gray-900', active);
        link.classList.toggle('text-white', active);
        link.classList.toggle('border-gray-900', active);
        link.classList.toggle('border-gray-300', !active);
        link.classList.toggle('text-gray-700', !active);
    });
}

function whythemeErgaMapClearMarkers() {
    whythemeErgaMapMarkers.forEach(function (entry) {
        entry.marker.setMap(null);
    });
    whythemeErgaMapMarkers = [];
}

function whythemeErgaMapRenderPoints(points) {
    whythemeErgaMapClearMarkers();

    if (!points.length) {
        return;
    }

    var bounds = new google.maps.LatLngBounds();

    points.forEach(function (point) {
        var position = { lat: parseFloat(point.lat), lng: parseFloat(point.lng) };

        var markerOptions = {
            position: position,
            map: whythemeErgaMapInstance,
            title: point.title || '',
        };

        if (point.icon) {
            markerOptions.icon = {
                url: point.icon,
                scaledSize: new google.maps.Size(36, 36),
            };
        }

        var marker = new google.maps.Marker(markerOptions);
        bounds.extend(position);

        marker.addListener('click', function () {
            var imageHtml = point.image
                ? '<img src="' + point.image + '" alt="" style="width:100%;height:120px;object-fit:cover;margin-bottom:8px;">'
                : '';
            var categoryHtml = point.category
                ? '<div style="font-size:12px;text-transform:uppercase;color:#6b7280;margin-bottom:4px;">' +
                  whythemeEscapeHtml(point.category) +
                  '</div>'
                : '';

            whythemeErgaMapInfoWindow.setContent(
                '<div style="max-width:220px;">' +
                    imageHtml +
                    categoryHtml +
                    '<strong>' + whythemeEscapeHtml(point.title) + '</strong><br>' +
                    '<a href="' + point.url + '">Δείτε το έργο</a>' +
                '</div>'
            );
            whythemeErgaMapInfoWindow.open(whythemeErgaMapInstance, marker);
        });

        whythemeErgaMapMarkers.push({ marker: marker, categorySlug: point.categorySlug || '' });
    });

    if (points.length === 1) {
        whythemeErgaMapInstance.setCenter(bounds.getCenter());
        whythemeErgaMapInstance.setZoom(10);
    } else {
        whythemeErgaMapInstance.fitBounds(bounds);
    }
}

function whythemeLoadErgaMapPoints(categorySlug) {
    var config = window.whythemeErgaMapData || {};
    if (!config.ajaxUrl) {
        return;
    }

    whythemeErgaMapSetSkeleton(true);

    var url = config.ajaxUrl +
        '?action=whytheme_erga_map_points' +
        '&category=' + encodeURIComponent(categorySlug || '');

    fetch(url)
        .then(function (res) {
            return res.json();
        })
        .then(function (json) {
            var points = json && json.success ? (json.data.points || []) : [];
            points = points.filter(function (p) {
                return p.lat !== '' && p.lng !== '';
            });
            whythemeErgaMapRenderPoints(points);
        })
        .catch(function () {})
        .finally(function () {
            whythemeErgaMapSetSkeleton(false);
        });
}

function whythemeErgaMapGoToCategory(slug, pushState) {
    whythemeErgaMapSetActiveFilter(slug);
    whythemeLoadErgaMapPoints(slug);

    if (pushState) {
        var url = new URL(window.location.href);
        if (slug) {
            url.searchParams.set('erga_category', slug);
        } else {
            url.searchParams.delete('erga_category');
        }
        window.history.pushState({ ergaCategory: slug }, '', url.toString());
    }
}

function whythemeWireErgaMapFilters() {
    document.addEventListener('click', function (e) {
        var link = e.target.closest('.js-erga-map-filter');
        if (!link) {
            return;
        }
        e.preventDefault();
        whythemeErgaMapGoToCategory(link.getAttribute('data-category') || '', true);
    });

    window.addEventListener('popstate', function () {
        whythemeErgaMapGoToCategory(whythemeErgaMapGetCategoryFromUrl(), false);
    });
}

window.whythemeInitErgaMap = function whythemeInitErgaMap() {
    var container = document.getElementById('erga-map');
    if (!container) {
        return;
    }

    whythemeErgaMapInstance = new google.maps.Map(container, {
        zoom: 6,
        center: { lat: 39.0742, lng: 21.8243 }, // Greece
    });
    whythemeErgaMapInfoWindow = new google.maps.InfoWindow();

    whythemeWireErgaMapFilters();
    whythemeLoadErgaMapPoints(whythemeErgaMapGetCategoryFromUrl());
};

document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('erga-map');
    if (!container) {
        return;
    }

    var data = window.whythemeErgaMapData || {};
    if (!data.hasKey) {
        whythemeErgaMapSetSkeleton(false);
        container.innerHTML =
            '<p style="padding:2rem;text-align:center;color:#6b7280;">Προσθέστε το Google Maps API key στις Ρυθμίσεις Θέματος → Χάρτης Έργων για να ενεργοποιηθεί ο χάρτης.</p>';
    }
});
